import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout/Layout'
import DatePicker from 'react-date-picker'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { convert } from '../../utils/convertDate'; // Import convert function
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { toast } from 'react-toastify';
import FGBondsServices from '../../services/fgbondsService';
import Modal from '../../components/Modals/Modal';
import BackButton from '../../components/BackButton';

// utils/formatMoney.ts
export const formatMoney = (value) => {
  if (value === null || value === undefined) return '';
  const stringValue = String(value);
  const cleaned = stringValue.replace(/\D/g, ''); // remove non-numeric
  if (!cleaned) return '';
  return new Intl.NumberFormat('en-NG').format(parseInt(cleaned, 10));
};


const ViewFGNBondsBookings = () => {
  const location = useLocation();
  const { slug } = useParams(); // Get slug from URL parameters (if used)
  const queryParams = new URLSearchParams(location.search); // Get query parameters
  const tBillIdFromQuery = queryParams.keys().next().value; // Get the first query parameter key, which is the T-Bill ID
  
  const currentMode = location.pathname.includes('/fgn_bonds/view') ? 'view' : (location.pathname.includes('/fgn_bonds/edit') ? 'edit' : 'create');
  const isViewMode = currentMode === 'view'; // Changed to only be true for 'view' mode

  const [fgnBondID, setFgnBondID] = useState("");
  const [fgnBondName, setFgnBondName] = useState("");
  const [volume, setVolume] = useState("");
  const [tenor, setTenor] = useState("");
  const [coupon, setCoupon] = useState("");
  const [maturityDate, setMaturityDate] = useState(new Date());
  const [firstCouponPaymentDate, setFirstCouponPaymentDate] = useState(new Date());
  const [secondCouponPaymentDate, setSecondCouponPaymentDate] = useState(new Date());
  const [cleanPrice, setCleanPrice] = useState("");
  const [redemptionValue, setRedemptionValue] = useState("");
  const [adminType, setAdminType] = useState("");
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [approvalModalTitle, setApprovalModalTitle] = useState("");
  const [approvalModalText, setApprovalModalText] = useState("");
  const [pendingApprovalAction, setPendingApprovalAction] = useState(null); // 'approve' or 'reject'

  const [treasuryData, setTreasuryData] = useState({
    createdBy: "",
    dateCreated: null,
    dateModified: null,
    fgnBondID: "",
    fgnBondName: "",
    volume: null,
    tenor: null,
    coupon: null,
    maturityDate: null,
    firstCouponPaymentDate: null,
    secondCouponPaymentDate: null,
    cleanPrice: null,
    redemptionValue: null,
    status: "",
    id: null,
    modifiedBy: "",
  })

  const [isLoading, setIsLoading] = useState(false)
  const [isListLoading, setISListLoading] = useState(false)
  const [isApproving, setIsApproving] = useState(false)
  const [isRejecting, setIsRejecting] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    const GetListings = async () => {
      setISListLoading(true)
        try {
          console.log("tBillIdFromQuery", tBillIdFromQuery)
            const response = await FGBondsServices.getFGBondById(parseInt(tBillIdFromQuery));
            console.log("listing details", response)
           if(response){
            const data = response.data;
            console.log("response", data)
            setTreasuryData(data)
            setFgnBondID(data.fgnBondID);
            setFgnBondName(data.fgnBondName);
            setVolume(data.volume);
            setTenor(data.tenor);
            setCoupon(data.coupon);
            setMaturityDate(new Date(convert(data.maturityDate)));
            setFirstCouponPaymentDate(new Date(convert(data.firstCouponPaymentDate)));
            setSecondCouponPaymentDate(new Date(convert(data.secondCouponPaymentDate)));
            setCleanPrice(data.cleanPrice);
            setRedemptionValue(data.redemptionValue);
            setISListLoading(false)
           }
        } catch (error) {
            console.error("Error fetching treasury bills:", error);
            setISListLoading(false)
        } finally {
          setISListLoading(false)
        }
    }
   if(slug !== "create"){
    GetListings();
   }
  }, [slug, tBillIdFromQuery])

  useEffect(() => {
    const userDetail = sessionStorage.getItem("user");
    const userDetails = JSON.parse(userDetail);
    setAdminType(userDetails.adminType);
  }, [slug])

  const handleSaveInternal = async () => {
    setIsLoading(true)
    const fgnBondRequest = {
        fgnBondID: fgnBondID,
        fgnBondName: fgnBondName,
        volume: parseFloat(volume),
        tenor: parseInt(tenor),
        coupon: parseFloat(coupon),
        maturityDate: maturityDate.toISOString(),
        firstCouponPaymentDate: firstCouponPaymentDate.toISOString(),
        secondCouponPaymentDate: secondCouponPaymentDate.toISOString(),
        cleanPrice: parseFloat(cleanPrice),
        redemptionValue: parseFloat(redemptionValue)
    }

    console.log("fgnBondRequest", fgnBondRequest)
    try {
      
      if(slug === "edit"){
        const response = await FGBondsServices.updateFGBondListings({...fgnBondRequest,
          fgnBondListingsID: parseInt(tBillIdFromQuery)
         })
        if(response){
          toast.success("Bond Updated")
          setIsLoading(false)
         setTimeout(() => {
          window.location.reload()
         }, 2000);
        }
      } else {
        console.log("fgnBondRequest create", fgnBondRequest)
        const response = await FGBondsServices.CreateFGBondListings(fgnBondRequest);
        console.log("natural", response)
        if(response){
          console.log("done", response)
          toast.success(response.message)
          setTimeout(() => {
            setIsLoading(false)
            navigate("/fgn-bonds")
          }, 2000);
        } else {
          setIsLoading(false)
        }
      }
    } catch (error) {
      setIsLoading(false)
    }
    // Implement save logic here
  };

  const handleApprove = async (injunction) => {
    setPendingApprovalAction(injunction);
    setApprovalModalTitle(injunction === 'approve' ? "Confirm Approval" : "Confirm Rejection");
    setApprovalModalText(injunction === 'approve' ? "Are you sure you want to approve this FGN Bond?" : "Are you sure you want to reject this FGN Bond?");
    setShowApprovalModal(true);
  };

  const confirmChanges = async () => {
    // Client-side validation
    if (!fgnBondID || !fgnBondName || !volume || !tenor || !coupon || !maturityDate || !firstCouponPaymentDate || !secondCouponPaymentDate || !cleanPrice || !redemptionValue) {
      toast.error("Please fill in all required fields.");
      return;
    }
    setShowConfirmationModal(true);
  };

  const handleConfirm = async () => {
    setShowConfirmationModal(false);
    await handleSaveInternal(); // Call the actual save logic
  };

  const handleCancel = () => {
    setShowConfirmationModal(false);
    setIsLoading(false);
  };

  const handleApproveConfirm = async () => {
    setShowApprovalModal(false);
    // Set the appropriate loading state based on the action
    if (pendingApprovalAction === 'approve') {
      setIsApproving(true);
    } else if (pendingApprovalAction === 'reject') {
      setIsRejecting(true);
    }
    try {
      const response = await FGBondsServices.approveRejectFGBond(treasuryData.id, pendingApprovalAction);
      if(response){
        toast.success(response.message);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (error) {
      console.error("Error during FGN Bond approval/rejection:", error);
      setIsApproving(false);
      setIsRejecting(false);
    }
  };

  const handleApprovalCancel = () => {
    setShowApprovalModal(false);
    setPendingApprovalAction(null);
    setIsApproving(false);
    setIsRejecting(false);
  }

  if(isListLoading){
    return (
      <Layout title={isViewMode ? "View FGN Bond" : (currentMode === 'edit' ? "Edit FGN Bond" : "Create FGN Bond")} pageTag={"fgn_bonds"} current={'/fgn-bonds/create'}>
        <div className="min-h-full">
          <div className="flex flex-1 flex-col">
            <div className="flex items-center justify-end w-full pr-10 font-bold">
              <div className="h-6 bg-gray-200 rounded animate-pulse w-20"></div>
            </div>
            <main className="flex-1">
              <div className="py-6">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
                  <div className="bg-white shadow sm:rounded-lg">
                    <div className="px-4 py-5 sm:p-6">
                      <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-3">
                        {/* Skeleton for all form fields */}
                        {Array.from({ length: 9 }).map((_, index) => (
                          <div key={index}>
                            <div className="h-4 bg-gray-200 rounded animate-pulse w-24 mb-2"></div>
                            <div className="h-10 bg-gray-200 rounded animate-pulse w-full"></div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </Layout>
    )
  }

 if(treasuryData && !isListLoading){
  const isInitiated = treasuryData.status?.toLowerCase() === "initiated";
  const isRejected = treasuryData.status?.toLowerCase() === "rejected";
  const isReadOnly = isViewMode || isInitiated || isRejected;
  
  return (
    <Layout title={isViewMode ? "View FGN Bond" : (currentMode === 'edit' ? "Edit FGN Bond" : "Create FGN Bond")} pageTag={"fgn_bonds"} current={'/fgn-bonds/create'}>
      <React.Fragment>
        <div className="min-h-full">
          <div className="flex flex-1 flex-col">
                <BackButton />
           <div className={`flex items-center justify-end w-full pr-10 font-bold ${treasuryData.status.toLowerCase() === "initiated" ? "text-blue-500" : "text-green-500"}`}>
         
              <h1>{treasuryData.status}</h1>
           </div>
            <main className="flex-1">
              <div className="py-6">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
                  <div className="bg-white shadow sm:rounded-lg">
                    <div className="px-4 py-5 sm:p-6">
                      <div className="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-3">
                        {/* FGN Bond ID */}
                        <div>
                          <label htmlFor="fgnBondID" className="block text-sm font-medium text-gray-700">FGN Bond ID</label>
                          <div className="mt-1">
                            <input
                              type="text"
                              name="fgnBondID"
                              id="fgnBondID"
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              value={fgnBondID}
                              onChange={!isReadOnly ? (e) => setFgnBondID(e.target.value) : undefined}
                              readOnly={isReadOnly}
                              placeholder="Enter FGN Bond ID"
                              required
                            />
                          </div>
                        </div>

                        {/* FGN Bond Name */}
                        <div>
                          <label htmlFor="fgnBondName" className="block text-sm font-medium text-gray-700">FGN Bond Name</label>
                          <div className="mt-1">
                            <input
                              type="text"
                              name="fgnBondName"
                              id="fgnBondName"
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              value={fgnBondName}
                              onChange={!isReadOnly ? (e) => setFgnBondName(e.target.value) : undefined}
                              readOnly={isReadOnly}
                              placeholder="Enter FGN Bond Name"
                              required
                            />
                          </div>
                        </div>

                        {/* Clean Price */}
                        <div>
                          <label htmlFor="cleanPrice" className="block text-sm font-medium text-gray-700">Clean Price</label>
                          <div className="mt-1">
                            <input
                              type="text"
                              name="cleanPrice"
                              id="cleanPrice"
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              value={`${cleanPrice}%`}
                              onChange={!isReadOnly ? (e) => setCleanPrice(e.target.value.replace('%', '')) : undefined}
                              readOnly={isReadOnly}
                              placeholder="Enter Clean Price"
                              required
                            />
                          </div>
                        </div>

                        {/* Input Volume */}
                        <div>
                          <label htmlFor="volume" className="block text-sm font-medium text-gray-700">Volume</label>
                          <div className="mt-1 relative rounded-md shadow-sm">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <span className="text-gray-500 sm:text-sm">₦</span>
                            </div>
                            <input
                              type="text"
                              name="volume"
                              id="volume"
                              className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md"
                              value={volume ? formatMoney(volume) : ''}
                              onChange={!isReadOnly ? (e) => {
                                const rawValue = e.target.value.replace(/,/g, '').replace(/\D/g, ''); 
                                setVolume(rawValue);
                              } : undefined}
                              readOnly={isReadOnly}
                              placeholder="Enter Volume"
                              required
                            />

                            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                              <span className="text-gray-500 sm:text-sm" id="price-currency">NGN</span>
                            </div>
                          </div>
                        </div>

                        {/* Tenor */}
                        <div>
                          <label htmlFor="tenor" className="block text-sm font-medium text-gray-700">Tenor</label>
                          <div className="mt-1">
                            <input
                              type="number"
                              name="tenor"
                              id="tenor"
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              value={tenor}
                              onChange={!isReadOnly ? (e) => setTenor(e.target.value) : undefined}
                              readOnly={isReadOnly}
                              placeholder="Enter Tenor"
                              required
                            />
                          </div>
                        </div>

                        {/* Coupon */}
                        <div>
                          <label htmlFor="coupon" className="block text-sm font-medium text-gray-700">Coupon</label>
                          <div className="mt-1">
                            <input
                              type="text"
                              name="coupon"
                              id="coupon"
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              value={`${coupon}%`}
                              onChange={!isReadOnly ? (e) => setCoupon(e.target.value.replace('%', '')) : undefined}
                              readOnly={isReadOnly}
                              placeholder="Enter Coupon"
                              required
                            />
                          </div>
                        </div>

                        {/* Maturity Date */}
                        <div>
                          <label htmlFor="maturityDate" className="block text-sm font-medium text-gray-700">Maturity Date</label>
                          <div className="mt-1">
                            <DatePicker
                              onChange={!isReadOnly ? setMaturityDate : undefined}
                              value={maturityDate}
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              disabled={isReadOnly}
                              calendarClassName="placeholder-gray-400"
                              required
                            />
                          </div>
                        </div>

                        {/* First Coupon Payment Date */}
                        <div>
                          <label htmlFor="firstCouponPaymentDate" className="block text-sm font-medium text-gray-700">First Coupon Payment Date</label>
                          <div className="mt-1">
                            <DatePicker
                              onChange={!isReadOnly ? setFirstCouponPaymentDate : undefined}
                              value={firstCouponPaymentDate}
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              disabled={isReadOnly}
                              calendarClassName="placeholder-gray-400"
                              required
                            />
                          </div>
                        </div>

                        {/* Second Coupon Payment Date */}
                        <div>
                          <label htmlFor="secondCouponPaymentDate" className="block text-sm font-medium text-gray-700">Second Coupon Payment Date</label>
                          <div className="mt-1">
                            <DatePicker
                              onChange={!isReadOnly ? setSecondCouponPaymentDate : undefined}
                              value={secondCouponPaymentDate}
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              disabled={isReadOnly}
                              calendarClassName="placeholder-gray-400"
                              required
                            />
                          </div>
                        </div>

                        {/* Redemption Value */}
                        <div>
                          <label htmlFor="redemptionValue" className="block text-sm font-medium text-gray-700">Redemption Value</label>
                          <div className="mt-1 relative rounded-md shadow-sm">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <span className="text-gray-500 sm:text-sm">₦</span>
                            </div>
                            <input
                              type="text"
                              name="redemptionValue"
                              id="redemptionValue"
                              className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm border-gray-300 rounded-md"
                              value={redemptionValue ? formatMoney(redemptionValue) : ''}
                              onChange={!isReadOnly ? (e) => {
                                const rawValue = e.target.value.replace(/,/g, '').replace(/\D/g, ''); 
                                setRedemptionValue(rawValue);
                              } : undefined}
                              readOnly={isReadOnly}
                              placeholder="Enter Redemption Value"
                              required
                            />
                            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                              <span className="text-gray-500 sm:text-sm">NGN</span>
                            </div>
                          </div>
                        </div>

                        {/* Yield */}
                        {/* <div className={`${currentMode === "create" && "hidden"}`}>
                          <label htmlFor="yieldValue" className="block text-sm font-medium text-gray-700">Yield</label>
                          <div className="mt-1">
                            <input
                              type="text"
                              name="yieldValue"
                              id="yieldValue"
                              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                              value={`${treasuryData.redemptionValue}%`}
                              onChange={!isViewMode ? (e) => setYieldValue(e.target.value.replace('%', '')) : undefined}
                              readOnly={isViewMode}
                              placeholder="Enter Yield Value"
                            />
                          </div>
                        </div> */}
                      </div>

                     {
                      currentMode !== "view" && !isInitiated && !isRejected &&  
                      <div className="mt-6 flex justify-end">
                        <button
                          type="button"
                          onClick={confirmChanges}
                          className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-gray-800 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                        >
                         {
                          isLoading ? "Loading..." : "Save Changes"
                         }
                        </button>
                      </div>
                     }
                     {
                      currentMode !== "view" && isInitiated && adminType.toLowerCase() === "checker" &&  
                      <div className="mt-6 flex justify-end">
                        <button
                          type="button"
                          onClick={handleSaveInternal}
                          className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-gray-800 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                        >
                         {
                          isLoading ? "Loading..." : "Approve Changes"
                         }
                        </button>
                      </div>
                     }

{
                      currentMode === "view" && adminType.toLowerCase() === "checker" && treasuryData.status.toLowerCase() === "initiated" && <div className="mt-6 flex justify-end">
                      <button
                        type="button"
                        onClick={() => handleApprove("approve")}
                        disabled={isApproving || isRejecting}
                        className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-gray-800 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                       {
                        isApproving ? "Loading..." : "Approve T-Bill Creation"
                       }
                      </button>
                      <button
                        type="button"
                        onClick={() => handleApprove("reject")}
                        disabled={isApproving || isRejecting}
                        className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-red-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                       {
                        isRejecting ? "Loading..." : "Reject T-Bill Creation"
                       }
                      </button>
                    </div>
                     }
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </React.Fragment>
      {/* Confirmation Modal */}
      <Modal
        isOpen={showConfirmationModal}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        modalTitle={currentMode === 'create' ? "Confirm FGN Bond Creation" : "Confirm Changes"}
        modalText={currentMode === 'create' ? "Are you sure you want to create this FGN Bond?" : "Are you sure you want to save these changes?"}
      />

      {/* Approval/Rejection Modal */}
      <Modal
        isOpen={showApprovalModal}
        onClose={handleApprovalCancel}
        onConfirm={handleApproveConfirm}
        onCancel={handleApprovalCancel}
        modalTitle={approvalModalTitle}
        modalText={approvalModalText}
      />
    </Layout>
  )
 }

 if(!treasuryData && !isLoading){
  return (
    <div>No data available</div>
  )
 }
}

export default ViewFGNBondsBookings